import { render, staticRenderFns } from "./ServiceItemDetails.vue?vue&type=template&id=1afde948&scoped=true"
import script from "./ServiceItemDetails.vue?vue&type=script&lang=ts"
export * from "./ServiceItemDetails.vue?vue&type=script&lang=ts"
import style0 from "./ServiceItemDetails.vue?vue&type=style&index=0&id=1afde948&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afde948",
  null
  
)

export default component.exports